import type {PropsWithChildren} from 'react'
import {Blankslate as PrimerBlankslate, useSlots} from '@primer/react/experimental'
import type {Icon} from '@primer/octicons-react'

Blankslate.Actions = PrimerBlankslate.PrimaryAction
Blankslate.Description = PrimerBlankslate.Description

const blankslateSlotConfig = {
  actions: Blankslate.Actions,
  description: PrimerBlankslate.Description,
}

export function Blankslate({
  children: slottedChildren,
  icon: BlankslateIcon,
  heading,
  description: descriptionText,
}: PropsWithChildren<{icon?: Icon; heading: string; description?: string}>) {
  const [{actions, description}] = useSlots(slottedChildren, blankslateSlotConfig)
  return (
    <PrimerBlankslate>
      {BlankslateIcon && (
        <PrimerBlankslate.Visual>
          <BlankslateIcon size="medium" />
        </PrimerBlankslate.Visual>
      )}
      <PrimerBlankslate.Heading>{heading}</PrimerBlankslate.Heading>
      {description || descriptionText
        ? (description ?? <PrimerBlankslate.Description>{descriptionText}</PrimerBlankslate.Description>)
        : null}
      {actions}
    </PrimerBlankslate>
  )
}
Blankslate.displayName = 'PanelList.Blankslate'
